export const contactSupport = () => {
  if (typeof window.FrontChat === 'undefined') {
    location.href = 'mailto:clients.uk@support.stream.co';
  } else {
    window.FrontChat('show');
  }
};
